import { useContext } from "react";
import { DesignMaxTheme } from "../themeProvider";

export const useDesignMaxTheme = () => {
    const context = useContext(DesignMaxTheme);

    return context;
};
